import axios from "axios";
import { ITracker } from "./tracker";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3000";

export interface IUser {
    _id: string;
    email: string;
    givenName: string;
    familyName: string;
    company?: string;
    role: string;
    isAdmin: boolean;
    isOnboarded: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface IUserWithTrackers extends IUser {
    trackers: ITracker[];
}

export interface IUsersWithTrackersResponse {
    data: IUserWithTrackers[];
    meta: {
        total: number;
        totalTrackers: number;
        activeTrackers: number;
        totalMatches: number;
    };
}

// Get all users (admin only)
export const getAllUsers = async () => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_BASE}/user/`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Get all users with their trackers (optimized for BO Dashboard, admin only)
export const getAllUsersWithTrackers = async (): Promise<IUsersWithTrackersResponse> => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_BASE}/user/admin/with-trackers`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Get a specific user (admin only)
export const getUser = async (userId: string) => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_BASE}/user/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};
